<p-table
	*ngIf="innerValue && innerValue.length > 0"
	#tableOperations
	[value]="innerValue"
	[paginator]="true"
	paginatorPosition="top"
	[alwaysShowPaginator]="false"
	[rows]="5"
	[showCurrentPageReport]="true"
	[totalRecords]="innerValue.length"
	currentPageReportTemplate="{{innerValue.length| number}} {{'common.table_total_records'|translate}}"
	paginatorDropdownAppendTo="body"
	[rowsPerPageOptions]="[5,10,25,50]"
	styleClass="p-datatable-sm p-datatable-thin-header p-datatable-gridlines table-scrollable-hover"
	[autoLayout]="true"
	responsiveLayout="scroll"
	scrollDirection="both"
	[scrollable]="true"
	scrollHeight="flex"
>
	<!-- Header -->
	<ng-template pTemplate="header">
		<tr>
			<th class="text-center nowrap">
				{{ 'textes.operation_type_label' | translate }}
			</th>

			<th class="text-center nowrap min-w-30rem">
				{{ 'textes.target_texte_reference' | translate }}
			</th>

			<th class="text-center min-w-15rem">
				{{ 'textes.target_texte_rubriques' | translate }}
			</th>

			<th class="text-center nowrap min-w-15rem">
				{{ 'textes.target_article' | translate }}
			</th>

			<th class="text-center nowrap min-w-15rem">
				{{ 'textes.target_position' | translate }}
			</th>

			<th class="text-center nowrap">
				{{ 'textes.date_application' | translate }}
			</th>

			<th class="text-center nowrap">
				{{ 'textes.date_execution' | translate }}
			</th>

			<th></th> <!-- Bouton d'actions -->
		</tr>
	</ng-template>

	<ng-template pTemplate="body" let-operation>
		<tr *ngIf="operation.txt_cible">
			<!-- Type opération -->
			<td class="text-center">{{operation.tot_code | operationType}}</td>

			<!-- Titre du texte cible, avec lien vers le texte -->
			<td class="text-center">
				<a
					class="text-blue-500 underline"
					uiSref="admin.textes.single"
					[uiParams]="{txt_id: operation.txt_id_cible}"
				>
					{{operation.txt_cible.txt_reference}}
				</a>
			</td>

			<!-- Rubriques du texte cible -->
			<td class="text-center">
				<div class="mb-1" *ngIf="operation.txt_cible.rubriques.length">
					{{operation.txt_cible.rubriques[0] | nomenclature}}
				</div>

				<ng-container *ngIf="operation.txt_cible.rubriques.length > 1">
					<p-accordion class="accordion-transparent">
						<p-accordionTab [header]="'common.and_x_more'|translate:{number: operation.txt_cible.rubriques.length -1}">
							<ng-container *ngFor="let rub of operation.txt_cible.rubriques; first as isFirst">
								<div class="text-sm mb-1" *ngIf="!isFirst">
									• {{rub | nomenclature}}
								</div>
							</ng-container>
						</p-accordionTab>
					</p-accordion>
				</ng-container>
			</td>

			<!-- Article cible -->
			<td class="text-center">{{operation | articleCible}}</td>

			<!-- Position cible -->
			<td class="text-center">{{operation | positionCible}}</td>

			<!-- Date d'application -->
			<td class="text-center">{{operation.otm_date_application | date:'shortDate'}}</td>

			<!-- Date d'exécution -->
			<td class="text-center">{{operation.otm_date_execution | date:'shortDate'}}</td>

			<!-- Actions -->
			<td class="nowrap">
				<button
					pButton
					icon="pi pi-eye"
					class="p-button-rounded p-button-text"
					(click)="showOperationDialog(operation)"
				></button>
				<button
					type="button"
					pButton
					icon="pi pi-trash"
					class="p-button-rounded p-button-text p-button-danger"
					(click)="showDeletionDialog(operation)"
					*ngIf="!readonly && !operation.otm_date_execution"
				></button>
			</td>
		</tr>
	</ng-template>

</p-table>

<!-- Bouton d'ajout -->
<div class="w-12 text-center mt-1">
    <button
        *ngIf="!readonly"
        type="button"
        pButton
        icon="pi pi-plus"
        class="p-button-rounded"
        (click)="showOperationDialog()"
        [title]="'textes.add_operation' | translate"
    ></button>
</div>